export default __webpack_public_path__ + "static/barcode-1151df58906496f224bb78ddc3d588ce.jpg";